import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotMembersQuery(chatbotId: string | undefined) {
  const { user } = useAuth();
  const isEnabled = Boolean(user) && Boolean(chatbotId);

  return useQuery({
    queryKey: chatbotQueryKeys.members(chatbotId ?? ''),
    enabled: isEnabled,
    queryFn: () => chatbotService.listMembers(chatbotId!),
  });
}
